import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { NotificationsService } from 'angular4-notifications';
import { Router } from '@angular/router';
// import { AuthenticationService } from './authentication.service';

// Doc : https://juristr.com/blog/2017/08/intercept-http-requests-in-angular/

@Injectable()
export class MyHttpLogInterceptor implements HttpInterceptor {

	constructor(
		private notificationService: NotificationsService, 
		private router:Router,
		private injector: Injector
		) { 	}


  	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


	  	// const auth = this.injector.get(AuthenticationService);
	  	let customReq: any;
  		customReq = request.clone({
	    // headers: request.headers.set('Access-Control-Allow-Origin', '*')
	    });


	    return next
	      .handle(customReq)
	      .do((ev: HttpEvent<any>) => {
	        if (ev instanceof HttpResponse) {
	          // console.log('Processing API', ev);
	        }
	      })
	      .catch(response => {
	      	switch (response.status) {
		      case 401:
		        // this.notificationService.error('Oups', 'An API 401 error occured');
	         //  	console.error('An API error occured', response);
		      case 403:
		        // this.notificationService.error('Oups', 'An API 403 error occured');
	         //  	console.error('An API error occured', response);
		      case 404:
		        // You could redirect to 404 page here
		        // return Observable.throw('your custom error here');
		        // console.error('An API error occured', response);
		        // return Observable.throw(response);
		        // this.router.navigate(["/error"]);
		      default:
		        return Observable.throw(response);
		    }

	      });
  	}
}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/services/http.interceptor.ts